import axios from "axios";
import { apiEndpoint } from '@iso/lib/helpers/endpoint';
import { authHeader } from '@iso/lib/helpers/authHeader';

export const operationsDashboardService = {
  getOverview,
};

function getOverview(propertyId) {
  return axios
    .get(`${apiEndpoint.operationsDashboard}?property_id=${propertyId}`, {
      headers: authHeader(),
    })
    .then((res) => {
      if (res && res.status === 200 && res.data.code === '0000') {
        return res.data;
      }
      return null;
    });
}
